import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { Modal } from 'react-bootstrap'
import Select from 'react-select'
import { toast } from 'react-toastify'

import { formatMoneyInput } from "helpers/helpers"
import { httpOk, GET } from "helpers/api"

function Index({
	users,
	selectedItem,
	setSelectedItem,
	createUpdate,
	modalCreateUpdate,
	toggleModalCreateUpdate,
	// партнёрский кабинет передаёт свой адрес: там нет «Произвольного», скидка до 20%
	packagesUrl = '/admin/tariff-packages',
	// начальный баланс задаёт только админ; агенту поле не показываем (сервер всё равно ставит 0)
	canSetBalance = true,
}) {
	const { t } = useTranslation()

	const types = [
		{ 'id': 'brand', 'name': "Бренд" },
		{ 'id': 'branch', 'name': "Филиал" },
	]

	const [countries, setCountries] = useState([])
	const [regions, setRegions] = useState([])
	const [districts, setDistricts] = useState([])
	const [posTypes, setPosTypes] = useState([])
	const [packages, setPackages] = useState([])

	async function getPackages() {
		// silent: пока бэк без пакетов, поле просто пустое — без тоста об ошибке
		const response = await GET(packagesUrl, {}, { silent: true })
		if (httpOk(response)) setPackages(response.data)
	}

	// Варианты списка пакета: «не менять» + пакеты; «По старому договору» — только у точки, которая уже на нём
	const packageOptions = [
		{ code: '', label: '— не менять —' },
		...packages
			.filter(item => item.code !== 'legacy' || selectedItem.tariff_plan_code === 'legacy')
			.map(item => ({
				code: item.code,
				label: item.name
					+ (item.price ? ` — ${formatMoneyInput(item.price)}` : '')
					+ (item.features?.delivery ? ' (с доставкой)' : ''),
			})),
	]

	// Пакет «Старт» / «Бизнес» подставляет цену по прайсу; «Произвольный» оставляет введённую
	function selectPackage(code) {
		const pkg = packages.find(item => item.code === code)
		setSelectedItem({
			...selectedItem,
			'tariff_plan_code': code || undefined,
			'tariff': pkg && pkg.price ? String(pkg.price) : selectedItem.tariff,
		})
	}

	async function handleSelectCountry(option) {
		// Сменили страну — регион и район прежней страны больше не подходят
		setSelectedItem({ ...selectedItem, 'country_id': option ? option.id : null, 'region_id': null, 'district_id': null })
		setRegions([])
		setDistricts([])
		if (option) getRegions(option.id)
	}

	async function handleSelectRegion(option) {
		setSelectedItem({ ...selectedItem, 'region_id': option ? option.id : null, 'district_id': null })
		setDistricts([])
		if (option) getDistricts(option.id)
	}

	async function handleSelectDistrict(option) {
		setSelectedItem({ ...selectedItem, 'district_id': option ? option.id : null })
	}

	async function getPosTypes() {
		const response = await GET('/helper/pos-types')
		if (httpOk(response)) setPosTypes(response.data)
	}

	async function getCountries() {
		const response = await GET('/helper/countries')
		if (httpOk(response)) setCountries(response.data)
	}

	async function getRegions(country_id) {
		const response = await GET(`/helper/regions/${country_id}`)
		if (httpOk(response)) setRegions(response.data)
	}

	async function getDistricts(region_id) {
		const response = await GET(`/helper/districts/${region_id}`)
		if (httpOk(response)) setDistricts(response.data)
	}

	// Обязательные поля точки при создании и редактировании; бэкенд проверяет то же самое (validatePosPayload)
	function validatePos() {
		if (!selectedItem.id && !selectedItem.type) return 'Выберите: бренд или филиал'
		// У существующей точки тип есть всегда (по умолчанию «Ресторан») — в поле он уже показан
		if (!selectedItem.id && !selectedItem.pos_type_id) return 'Выберите тип точки: торговая точка или склад'
		if (!selectedItem.country_id) return 'Выберите страну'
		if (!selectedItem.region_id) return 'Выберите регион'
		if (districts.length > 0 && !selectedItem.district_id) return 'Выберите район'
		if (!selectedItem.name) return 'Укажите название точки'
		if (!selectedItem.tariff) return 'Укажите тариф'
		return null
	}

	function handleSubmit(e) {
		const error = validatePos()
		if (error) {
			e.preventDefault()
			toast.dismiss()
			toast.error(error)
			return
		}
		createUpdate(e)
	}

	useEffect(() => {
		getCountries()
		getPosTypes()
		getPackages()

		if (selectedItem.id && selectedItem.country_id) getRegions(selectedItem.country_id)
		if (selectedItem.id && selectedItem.region_id) getDistricts(selectedItem.region_id)
	}, [modalCreateUpdate]) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			{/* MODAL CREATE UPDATE*/}
			<Modal Modal show={modalCreateUpdate} animation={false} centered
				dialogClassName="update-modal-width"
				onHide={() => toggleModalCreateUpdate()
				}>
				<Modal.Header closeButton>
					<Modal.Title>
						{!selectedItem.id ?
							<span>{t('create')}</span>
							:
							<span>{t('edit')}</span>
						}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={(e) => handleSubmit(e)} autoComplete="off">
						{!selectedItem.id &&
							<div className="form-group">
								<label>{t('type')}<span className="required-mark">*</span></label>
								<Select
									isDisabled={selectedItem.id}
									options={types}
									value={types.find(option => option.id === selectedItem.type) || ''}
									onChange={(option) => setSelectedItem({ ...selectedItem, 'type': option ? option.id : null })}
									placeholder=""
									noOptionsMessage={() => t('list_empty')}
									getOptionLabel={(option) => option.name}
									getOptionValue={(option) => option.id}
								/>
							</div>
						}

						{selectedItem.type === 'brand' &&
							<div className="d-flex gap-2">
								<div className="form-group w-100">
									<label>{t('name')}</label>
									<input type="text" className="form-control" name="first_name" value={selectedItem.first_name ?? ''}
										onChange={(e) => setSelectedItem({ ...selectedItem, 'first_name': e.target.value })} />
								</div>

								<div className="form-group w-100">
									<label>{t('login')}</label>
									<input type="text" className="form-control"
										disabled={selectedItem.id}
										name="login" value={selectedItem.login ?? ''}
										onChange={(e) => setSelectedItem({ ...selectedItem, 'login': e.target.value.toLowerCase() })} />
								</div>
								<div className="form-group w-100">
									<label>{t('password')}</label>
									<input type="text" className="form-control"
										name="password" value={selectedItem.password ?? ''}
										onChange={(e) => setSelectedItem({ ...selectedItem, 'password': e.target.value })} />
								</div>
								<div className="form-group w-100">
									<label>{t('phone')}</label>
									<input type="number" className="form-control" name="phone" value={selectedItem.phone ?? ''}
										onChange={(e) => setSelectedItem({ ...selectedItem, 'phone': e.target.value })} />
								</div>
							</div>
						}
						{selectedItem.type === 'branch' &&
							<div className="form-group">
								<label>{t('users')}</label>
								<Select
									options={users}
									value={users.find(option => option.login === selectedItem.login) || ''}
									onChange={(option) => setSelectedItem({ ...selectedItem, 'login': option ? option.login : null })}
									placeholder=""
									noOptionsMessage={() => t('list_empty')}
									getOptionLabel={(option) => option.login}
									getOptionValue={(option) => option.id}
								/>
							</div>
						}

						{/* При редактировании блока «Тип / бренд» нет — разделитель над странами не нужен */}
						{!selectedItem.id && <hr />}

						<div className="d-flex gap-2 w-100">
							<div className="form-group w-100">
								<label>{t('countries')}<span className="required-mark">*</span></label>
								<Select
									isClearable
									options={countries}
									value={countries.find(option => option.id === selectedItem.country_id) || ''}
									onChange={(option) => handleSelectCountry(option)}
									placeholder=""
									noOptionsMessage={() => t('list_empty')}
									getOptionLabel={(option) => option.name}
									getOptionValue={(option) => option.id}
								/>
							</div>
							<div className="form-group w-100">
								<label>{t('regions')}<span className="required-mark">*</span></label>
								<Select
									isClearable
									options={regions}
									value={regions.find(option => option.id === selectedItem.region_id) || ''}
									onChange={(option) => handleSelectRegion(option)}
									placeholder=""
									noOptionsMessage={() => t('list_empty')}
									getOptionLabel={(option) => option.name}
									getOptionValue={(option) => option.id}
								/>
							</div>
							<div className="form-group w-100">
								<label>{t('districts')}{districts.length > 0 && <span className="required-mark">*</span>}</label>
								<Select
									isClearable
									options={districts}
									value={districts.find(option => option.id === selectedItem.district_id) || ''}
									onChange={(option) => handleSelectDistrict(option)}
									placeholder=""
									noOptionsMessage={() => t('list_empty')}
									getOptionLabel={(option) => option.name}
									getOptionValue={(option) => option.id}
								/>
							</div>
						</div>

						{/* Название и телефон точки (телефон — только у существующей: у новой его берут из бренда) */}
						<div className="d-flex gap-2">
							<div className="form-group w-100">
								<label>{t('name2')}<span className="required-mark">*</span></label>
								<input type="text" className="form-control" name="name" value={selectedItem.name}
									onChange={(e) => setSelectedItem({ ...selectedItem, 'name': e.target.value })} />
							</div>
							{selectedItem.id &&
								<div className="form-group w-100">
									<label>{t('phone')}</label>
									<input type="text" className="form-control" name="phone" placeholder="998901234567"
										inputMode="numeric" maxLength={13}
										value={selectedItem.phone ?? ''}
										onChange={(e) => setSelectedItem({ ...selectedItem, 'phone': e.target.value.replace(/\D/g, '') })} />
								</div>
							}
						</div>
						{/* Тип точки и ИНН. Склад не пробивает чеки — в «Заботе о клиентах» его не считают неработающим */}
						<div className="d-flex gap-2">
							<div className="form-group w-100" style={{ minWidth: 0 }}>
								<label>Тип точки<span className="required-mark">*</span></label>
								{/* У новой точки тип не подставляем — пусть выберут явно: торговая точка или склад */}
								<Select
									options={posTypes}
									value={posTypes.find(option => option.id === (selectedItem.id ? (selectedItem.pos_type_id ?? 1) : selectedItem.pos_type_id)) || ''}
									onChange={(option) => setSelectedItem({ ...selectedItem, 'pos_type_id': option ? option.id : null })}
									placeholder=""
									noOptionsMessage={() => t('list_empty')}
									getOptionLabel={(option) => option.name}
									getOptionValue={(option) => option.id}
								/>
							</div>
							<div className="form-group w-100">
								<label>{t('tin')}</label>
								<input type="text" className="form-control" name="tin" value={selectedItem.tin ?? ''}
									onChange={(e) => setSelectedItem({ ...selectedItem, 'tin': e.target.value })} />
							</div>
						</div>
						{/* Пакет, цена и баланс — своей строкой: в одной строке с названием и ИНН поля
							сжимались, а список пакета был выше соседних инпутов */}
						<div className="d-flex gap-2">
							<div className="form-group" style={{ flex: 2, minWidth: 0 }}>
								<label>Пакет</label>
								<Select
									options={packageOptions}
									value={packageOptions.find(option => option.code === (selectedItem.tariff_plan_code ?? '')) || packageOptions[0]}
									onChange={(option) => selectPackage(option ? option.code : '')}
									placeholder=""
									isSearchable={false}
									noOptionsMessage={() => t('list_empty')}
									getOptionLabel={(option) => option.label}
									getOptionValue={(option) => option.code}
								/>
							</div>
							<div className="form-group" style={{ flex: 1, minWidth: 0 }}>
								<label>{t('tariff')}<span className="required-mark">*</span></label>
								<input type="text" className="form-control" name="tariff"
									value={formatMoneyInput(selectedItem.tariff) ?? ''}
									onChange={(e) => setSelectedItem({ ...selectedItem, 'tariff': e.target.value.replace(/[^0-9.]/g, '') })} />
							</div>
							{(canSetBalance || selectedItem.id) &&
								<div className="form-group" style={{ flex: 1, minWidth: 0 }}>
									<label>{t('balance')}</label>
									<input type="text" className="form-control" name="balance"
										disabled={selectedItem.id || !canSetBalance}
										placeholder="0"
										value={formatMoneyInput(selectedItem.balance) ?? ''}
										onChange={(e) => setSelectedItem({ ...selectedItem, 'balance': e.target.value.replace(/[^-0-9.]/g, '') })} />
								</div>
							}
						</div>
						<div className="d-flex justify-content-between">
							<p className="fw-600 vertical-center">{t('is_vat_payer')}</p>
							<div className="form-check form-switch form-switch-md">
								<input type="checkbox" className="form-check-input" name="is_vat_payer"
									checked={selectedItem?.is_vat_payer ?? false}
									onChange={(e) => setSelectedItem({ ...selectedItem, 'is_vat_payer': e.target.checked })} />
							</div>
						</div>
						<div className="d-flex w-100 mt-3 gap-2">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => toggleModalCreateUpdate()}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-primary w-100">
								{t('save')}
							</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL CREATE UPDATE*/}
		</>
	)
}

export default Index